/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kinds: NonNullable<unknown> }} Artifacts_Download_Unsupported_KindInputs */



/**
* | output |
* | --- |
* | "These cannot be downloaded as files: {kinds}. Deselect them to export the rest." |
*
* @param {Artifacts_Download_Unsupported_KindInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_download_unsupported_kind = /** @type {((inputs: Artifacts_Download_Unsupported_KindInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Download_Unsupported_KindInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese können nicht als Datei heruntergeladen werden: ${i?.kinds}. Entferne sie aus der Auswahl, um den Rest zu exportieren.`)
	return /** @type {LocalizedString} */ (`These cannot be downloaded as files: ${i?.kinds}. Deselect them to export the rest.`)
});